import { createAsyncSliceWithDataAndQuery } from '../createAsyncSliceWithDataAndQuery';
import { getConversationsAsync } from '../../API/conversations/getConversationsAsync';
import { createDefaultPageData } from 'types/rest/IPageData';

export const { slice: clientConversationsSlice, asyncAction: loadConversationsAction } =
  createAsyncSliceWithDataAndQuery('clientConversationsSlice', getConversationsAsync, createDefaultPageData());
